import { CustomRuleFixer } from '../components/fixer-components/custom-rule-fixer/custom-fixer';
import { DropdownFixer } from '../components/fixer-components/dropdown-fixer/dropdown-fixer';
import { EvergreenRuleFixer } from '../components/fixer-components/evergreen-rule/evergreen-rule-fixer';
import { InputFixer } from '../components/fixer-components/input-fixer/input-fixer';
import { RadioGroupFixer } from '../components/fixer-components/radio-group-fixer/radio-group-fixer';
import { ToggleRuleFixer } from '../components/fixer-components/toggle-rule-fixer';
import { FixerType } from '../types';
export const ruleContentMapper = {
  [FixerType.InputRule]: InputFixer,
  [FixerType.DropdownRule]: DropdownFixer,
  [FixerType.EvergreenRule]: EvergreenRuleFixer,
  [FixerType.Custom]: CustomRuleFixer,
  [FixerType.RadioGroupRule]: RadioGroupFixer,
  [FixerType.ToggleRule]: ToggleRuleFixer
};
//# sourceMappingURL=rule-content-mapper.js.map